import { useMemo } from 'react';

import { Bean, MoneyPatternType, ValidationRules } from '@dreryk/react-common';
import { InteractiveTable, InteractiveTableCellProps, useInteractiveTableContext } from '@dreryk/react-components';

import { MedicalServicePractitionerBean } from '../../practitioner.types';

type MedicalServicePractitionerIndividualPriceCellProps = InteractiveTableCellProps<number | null> & {
   readonly defaultValue: number | null;
};

export const MedicalServicePractitionerIndividualPriceCell = (
   props: MedicalServicePractitionerIndividualPriceCellProps
): JSX.Element => {
   const { getCellValue } = useInteractiveTableContext<MedicalServicePractitionerBean>();
   const usingDefaultConfiguration = getCellValue('usingDefaultConfiguration', props.index);

   const validationRules = useMemo<ValidationRules<Bean>>(() => {
      return {
         required: !usingDefaultConfiguration,
      };
   }, [usingDefaultConfiguration]);

   return (
      <InteractiveTable.MoneyInputCell
         testId={props.testId}
         name={props.name}
         index={props.index}
         validationRules={validationRules}
         defaultValue={props.defaultValue}
         disabled={usingDefaultConfiguration}
         minSize={5}
         maxSize={9}
         min={1}
         max={999999.99}
         pattern={MoneyPatternType.POSITIVE}
      />
   );
};
